export default __webpack_public_path__ + "static/0-72e5d538ba36646bc527cccd1a610f45.jpg";